import { defineComponent as r, h as l, Teleport as s, computed as d, toRef as i } from "vue";
import { getSlot as o } from "./highrise719.mjs";
import n from "./highrise627.mjs";
const h = r({
  name: "LazyTeleport",
  props: {
    to: {
      type: [String, Object],
      default: void 0
    },
    disabled: Boolean,
    show: {
      type: Boolean,
      required: !0
    }
  },
  setup(t) {
    return {
      showTeleport: n(i(t, "show")),
      mergedTo: d(() => {
        const { to: e } = t;
        return e ?? "body";
      })
    };
  },
  render() {
    return this.showTeleport ? this.disabled ? o("lazy-teleport", this.$slots) : l(s, {
      disabled: this.disabled,
      to: this.mergedTo
    }, o("lazy-teleport", this.$slots)) : null;
  }
});
export {
  h as default
};
